export const GlobalErrorHandler = {
  handleError: (error, showAlert) => {
    // Handle network errors / no response (e.g. timeout, CORS, offline)
    if (!error.response) {
      const message = error?.message || 'Network error. Please check your connection and try again.';
      if (showAlert) {
        showAlert('error', message);
      } else {
        localStorage.setItem('globalError', JSON.stringify({ type: 'error', message }));
      }
      return { handled: true, status: null, message };
    }

    const { status, data } = error.response;

    // Handle Rate Limiting (429)
    if (status === 429) {
      const message = data?.message || 'Too many requests. Please wait a few minutes before trying again.';
      if (showAlert) {
        showAlert('error', message);
      } else {
        localStorage.setItem('globalError', JSON.stringify({ type: 'error', message }));
      }
      return { handled: true, status, message };
    }

    // Handle Account Locked (423)
    if (status === 423) {
      const message = data?.message || 'Your account is temporarily locked. Please reset your password.';
      if (showAlert) {
        showAlert('error', message);
      }
      return { handled: true, status, message };
    }

    // Not a status this handler deals with
    return { handled: false, status, message: null };
  },
};

export default GlobalErrorHandler;